import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn, CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { AUTH_PROVIDER } from './auth-provider.token';

export const authGuardWrapper: CanActivateFn & CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authProvider = inject(AUTH_PROVIDER);
  return authProvider.canActivate(route, state);
};
